import type { ColumnDef } from '@tanstack/react-table';
import type { Callback } from 'ts/base/Callback';
import { SortableTable } from 'ts/base/table/SortableTable';
import { RelativeDateTimeCell } from 'ts/commons/components/DateCell';
import { Markdown } from 'ts/commons/markdown/Markdown';
import { ESortOrder } from 'typedefs/ESortOrder';
import type { ResolvedTask } from 'typedefs/ResolvedTask';

type TaskTableProps = {
	tasks: ResolvedTask[];
	onSelectTask: Callback<number>;
};

/** Sortable table for the task selection dialog. By default, sorted by creation date of task */
export function TaskTable({ tasks, onSelectTask }: TaskTableProps) {
	return (
		<SortableTable
			striped
			selectable
			data-testid="task-table"
			data={tasks}
			columnDefinitions={TASK_COLUMNS}
			getRowProps={row => ({
				onClick: () => onSelectTask(row.original.id)
			})}
			defaultSortOptions={{
				sortByField: 'created',
				sortOrder: ESortOrder.DESCENDING
			}}
		/>
	);
}

const TASK_COLUMNS: Array<ColumnDef<ResolvedTask>> = [
	{
		accessorKey: 'id',
		header: 'ID'
	},
	{
		accessorKey: 'subject',
		header: 'Subject',
		cell: ({ row: { original } }) => <Markdown inline markdownText={original.subject} />
	},
	{
		accessorKey: 'created',
		header: 'Created',
		cell: RelativeDateTimeCell
	}
];
